export default "__VITE_ASSET__DGe0sIDv__"